import {Component, ComponentFactoryResolver, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CellDecoratorHostDirective} from '@shared/directive/cell-decorator-host.directive';
import {ParticleService} from '@core/services/particle.service';
import {TimeZoneService} from '@core/services/time-zone.service';
@Component({
    standalone: false,
    selector: 'lib-admin-panel-cell-decorator',
  templateUrl: './admin-panel-cell-decorator.component.html',
  styleUrls: ['./admin-panel-cell-decorator.component.scss']
})
export class AdminPanelCellDecoratorComponent implements OnInit, OnDestroy, CellComponent {

  item: any;
  sourceType: string;
  isMouseOver: boolean;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  isActive: boolean;
  isInActive: boolean;

  @ViewChild(CellDecoratorHostDirective, {static: true}) particleCellDecoratorHost: CellDecoratorHostDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private particleService: ParticleService,
              private timeZoneService: TimeZoneService) { }

  ngOnInit() {
    this.renderCell();
  }

  ngOnDestroy(): void {
  }

  renderCell () {
    const currentComponent = this.particleService.getCellComponent(this.fieldDefinition.cellViewer);
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    this.particleCellDecoratorHost.viewContainerRef.clear();
    const component = this.particleCellDecoratorHost.viewContainerRef.createComponent(currentComponent);
    const cellComponent = component.instance as CellComponent;

    cellComponent.item = this.item;
    cellComponent.fieldDefinition = this.fieldDefinition;
    if (cellComponent.valueChanged) {
      cellComponent.valueChanged.subscribe(value => this.valueChanged.emit(value));
    }
    cellComponent.sourceType = this.sourceType;

    this.isActive = false;
    this.isInActive = false;

    if (cellComponent.fieldDefinition.key === 'Status') {
      this.isActive = cellComponent.item.cells['Status'].displayText.toLowerCase() === 'active';
      this.isInActive = cellComponent.item.cells['Status'].displayText.toLowerCase() === 'inactive';
    }

    if (cellComponent.fieldDefinition.key === 'ExpiryDate') {
      const today = this.timeZoneService.getUTCDateWithoutTime(new Date());
      const expiryDate = this.timeZoneService.getUTCDateWithoutTime(cellComponent.item.cells['ExpiryDate'].displayText);
      this.isInActive = today.getTime() > expiryDate.getTime();
    }
  }

}
